module.exports = "请使用简洁明确的语言描述你遇到的问题。[*什么是简洁明确的标题？*](#simple-clear-title)\n"